import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: 58,
      height: 32,
      padding: 0,
    },
    switchBase: {
      padding: 3,
      '&$checked': {
        transform: 'translateX(25px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: theme.palette.primary.main,
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 25,
      height: 25,
      boxShadow: 'none',
      margin: '0 1px',
    },
    track: {
      borderRadius: 32 / 2,
      backgroundColor: theme.palette.grey[300],
    },
    checked: {},
    focusVisible: {},
  }),
);

export default useStyles;
